export const popularTokens_RINKEBY: any = [
    "0xc778417e063141139fce010982780140aa0cd5ab", //WETH
    "0x5457cc9b34ea486eb8d3286329f3536f71fa8a8b", //SUSHI
    "0x4dbcdf9b62e891a7cec5a2568c3f4faf9e8abe2b", //USDC
    "0xc7ad46e0b8a400bb3c915120d284aafba8fc4735", //DAI
    "0xd9ba894e0097f8cc2bbc9d24d308b98e36dc6d02", //USDT
  ];
  


  export const popularTokens_BSC: any = [
    '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c', //BNB
    '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82', //CAKE
    '0xe9e7cea3dedca5984780bafc599bd69add087d56', //BUSD
  
  ]


  export const popularTokens_MUMBAI: any = [
    "0x5b67676a984807a212b1c59ebfc9b3568a474f0a", //WMATIC
    "0x742dfa5aa70a8212857966d491d67b09ce7d6ec7", //USDC
    "0x3813e82e6f7098b9583fc0f33a962d02018b6803", //USDT
    "0xe03489d4e90b22c59c5e23d45dfd59fc0db8a025", //SAND
    "0xcb1e72786a6eb3b44c2a2429e317c8a2462cfeb1", //DAI
  ];

  export const popularTokens_ARBITRUM: any = [
    "0x82af49447d8a07e3bd95bd0d56f35241523fbab1", //WETH
    "0xd4d42f0b6def4ce0383636770ef773390d85c61a", //SUSHI
    "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8", //USDC
    "0xda10009cbd5d07dd0cecc66161fc93d7c9000da1", //DAI
    "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9", //USDT
  ];


  export const popularTokens_POLYGON: any = [
    "0x2791bca1f2de4661ed88a30c99a7a9449aa84174", //USDC
    "0xc2132d05d31c914a87c6611c10748aeb04b58e8f", //USDT
    "0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063", //DAI
    "0x3cef98bb43d732e2f285ee605a8158cde967d219", //BAT
    "0x8505b9d2254a7ae468c0e9dd10ccea3a837aef5c", //COMP
  ];